import { initialLtmState, LtmActionTypes } from '../types';
import createAsyncMapReducer from '~lib/shared/redux/reducers/async-map-reducer';
const getSubscriptionDetailReducer = createAsyncMapReducer(LtmActionTypes.GET_SUBSCRIPTION_DETAIL, initialLtmState.getSubscriptionDetail);
export default getSubscriptionDetailReducer;
